import { EVENT_TYPE } from '@lighthouse/core'
import type { ActionFlowNode, FlowNodeResultADT, OpenLinkActionConfig, OpenLinkActionConfigure } from '@lighthouse/shared'
import { generateVariableValue, getJumpUrl, openNewBrowserPage } from '@lighthouse/shared'
import { safeToString } from '@lighthouse/tools'
import { t } from 'i18next'

import type { ExecuteActionParams } from '../type'

export const handleOpenLinkStream = async (
    node: ActionFlowNode<OpenLinkActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config || !config.link) {
        throw new Error(t('configurationNotPerfect'))
    }

    const realLink = handleOpenLink(config, params)

    return await Promise.resolve({
        type: 'args',
        success: true,
        data: [{ id: '', name: 'link', innerType: 'TEXT', value: realLink }]
    })
}

export const handleOpenLink = (config: OpenLinkActionConfig, params: ExecuteActionParams) => {
    const { target, link } = config
    const { eventType } = params
    if (!link) {
        return
    }
    const url = generateVariableValue({
        innerType: 'TEXT',
        jsonContent: link,
        extraParams: params,
        options: { format: true, useFileUrl: true }
    })
    if (!url) {
        return
    }

    const realUrl = safeToString(url)
    if (eventType !== EVENT_TYPE.LOAD && eventType !== EVENT_TYPE.LOAD_DATA) {
        openNewBrowserPage(getJumpUrl(realUrl), target)
    }

    return realUrl
}
